import { useGameStore } from '../../store/gameStore';
import { CHARACTERS } from '../../data';
import { getCharSelectPath } from '../../data/assets';
import { requestFullscreen, useMobileDetect } from '../../hooks/useMobileDetect';
import styles from './CharacterSelect.module.css';

export default function CharacterSelect() {
  const { players, selectCharacter, startGame, setPhase } = useGameStore();
  const humanPlayer = players[0];
  const { isMobile } = useMobileDetect();

  const handleConfirm = () => {
    if (isMobile) requestFullscreen();
    startGame();
  };

  return (
    <div className={styles.container}>
      <div className={styles.bgDecor}>
        <div className={styles.bgGlow} />
      </div>

      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>选择你的角色</h2>
          <p className={styles.subtitle}>
            每个角色都有独特的被动技能，选择最适合你的策略
          </p>
        </div>

        <div className={styles.charGrid}>
          {CHARACTERS.map(c => (
            <button
              key={c.id}
              className={`${styles.charCard} ${
                humanPlayer?.characterId === c.id ? styles.charCardActive : ''
              }`}
              onClick={() => humanPlayer && selectCharacter(humanPlayer.id, c.id)}
            >
              <img
                src={getCharSelectPath(c.id)}
                alt={c.name}
                className={styles.charImg}
              />
              <span className={styles.charName}>{c.name}</span>
              <span className={styles.charSkillName}>{c.passiveName}</span>
              <span className={styles.charSkillDesc}>{c.passiveDesc}</span>
            </button>
          ))}
        </div>

        <div className={styles.playersSection}>
          <h3 className={styles.playersTitle}>本局玩家</h3>
          <div className={styles.playersList}>
            {players.map((p, i) => {
              const c = CHARACTERS.find(ch => ch.id === p.characterId);
              return (
                <div key={p.id} className={styles.playerItem}>
                  <img
                    src={getCharSelectPath(p.characterId)}
                    alt={c?.name}
                    className={styles.playerAvatar}
                  />
                  <span className={styles.playerLabel}>
                    {i === 0 ? '👤 你' : '🤖 Bot'}
                  </span>
                  <span className={styles.playerName}>{p.name}</span>
                  <span className={styles.playerChar}>
                    {c?.name} · {c?.passiveName}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.backBtn} onClick={() => setPhase('lobby')}>
            返回
          </button>
          <button className={styles.confirmBtn} onClick={handleConfirm}>
            <span>🎮</span> 开始对战
          </button>
        </div>
      </div>
    </div>
  );
}
